const register = {
  loginCredentials: "بيانات اعتماد تسجيل الدخول", // translated 
  companyInformation: "معلومات الشركة", // translated 
  contactDetails: "بيانات المتصل", // translated 
  businessName: "الاسم التجاري", // translated 
  businessAddress: "عنوان العمل", // translated 
  registrationCode: "رمز التسجيل", // translated 
  businessRegistrationNumber: "رقم تسجيل الأعمال", // translated 
  websiteUrl: "رابط الموقع", // translated 
  mobilePhone: "تليفون محمول", // translated 
  regionStateProvince: "المنطقة/الولاية/المقاطعة", // translated 
  legalTitle: "العنوان القانوني", // translated 
  city: "مدينة", // translated 
  postalCode: "رمز بريدي", // translated 
  registrationSuccess: "نجاح التسجيل.", // translated 
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "يرجى الانتظار بضع دقائق وسيتم إعادة توجيهك إلى الصفحة الرئيسية.", // translated 
};



export default register;
